var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1429 12H10.0333H1.10951H0V10.9095V8.78977H1.10951V10.9095H10.0333V8.78977H11.1429V10.9095V12ZM5.58532 8.74499L5.57143 8.7581L2.47792 5.71715L3.26241 4.94558L5.01695 6.67V0H6.12591V6.67055L7.88045 4.94558L8.66549 5.71715L5.58532 8.74499Z",
    fill: "#0091E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7647b2c2ba942d342ae5f68a90f63db1.svg";
export { ForwardRef as ReactComponent };